














































































































































































import { Component, Vue } from "vue-property-decorator";
import { getUserInfo, userList } from "@/api/users";
import { shipAuth, User } from "@/api/model/user";
import account_edit from "./account_edit.vue";
import { ShipSearch, shipSearch } from "@/api/user";

@Component({
  components: { account_edit },
  name: "rolelist",
  filters: {
    statusFilter: (status: string) => {
      const statusMap: { [key: string]: string } = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toISOString();
    },
  },
})
export default class extends Vue {
  private listLoading = true;
  private page = 1;
  private page_size = 10;
  private list: Array<ShipSearch> = [];
  private total: number = 0;
  private weight:number = 0;
  private search: ShipSearch = <ShipSearch>{};
  private editId = 0;
  private showEdit = false;
  private u_def_7 = <string[]>[];
  private u_def_8 = <string[]>[];
  private u_def_29 = <string[]>[];
  private u_def_30 = <string[]>[];
  private auth = shipAuth;
  private user = <User>{};
  created() {
    this.initData();

  }
  private async initData() {
    getUserInfo().then(res => {
      console.log(res)
      this.user = res
    })
    await this.getList();
  }
  private async getList() {
    this.listLoading = true;
    var u_def_7_s = ""
    var u_def_7_e = ""
    var u_def_8_s = ""
    var u_def_8_e = ""
    var u_def_29_s = ""
    var u_def_29_e = ""
    var u_def_30_s = ""
    var u_def_30_e = ""
    if (this.u_def_7 && this.u_def_7.length == 2) {
      u_def_7_s = this.u_def_7[0].replace(/[^0-9]/g, ""); //装船时间
      u_def_7_e = this.u_def_7[1].replace(/[^0-9]/g, "");
      console.log(u_def_7_s)
    }
    if (this.u_def_8 && this.u_def_8.length == 2) {
      u_def_8_s = this.u_def_8[0].replace(/[^0-9]/g, ""); //发船时间
      u_def_8_e = this.u_def_8[1].replace(/[^0-9]/g, "");
    }
    if (this.u_def_29 && this.u_def_29.length == 2) {
      u_def_29_s = this.u_def_29[0].replace(/[^0-9]/g, ""); //到港时间
      u_def_29_e = this.u_def_29[1].replace(/[^0-9]/g, "");
    }
    if (this.u_def_30 && this.u_def_30.length == 2) {
      u_def_30_s = this.u_def_30[0].replace(/[^0-9]/g, ""); //卸货时间
      u_def_30_e = this.u_def_30[1].replace(/[^0-9]/g, "");
    }

    shipSearch(
      this.search,
      this.page,
      this.page_size,
      u_def_7_s,
      u_def_7_e,
      u_def_8_s,
      u_def_8_e,
      u_def_29_s,
      u_def_29_e,
      u_def_30_s,
      u_def_30_e
    )
      .then((res) => {
        console.log(res);
        this.list = res.list;
        this.total = res.total;
        this.weight = res.weight;
      })
      .finally(() => {
        this.listLoading = false;
      });
  }
  private pageChange(page: number) {
    this.page = page;
    this.getList();
  }

  private onSearch() {
    this.page = 1;
    this.getList();
  }
}
